export function DuelIntroComponent() {
  return (
    <div className=" items-center justify-center flex h-full w-full  ">
      <img className=" w-[1200px]  object-cover" src="/duel-intro.svg" alt="" />
    </div>
  );
}
